var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-path2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.000000, -617.000000) translate(36.000000, 617.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M9.054 13.311c.43-.131.54-.08.619 0 .082.084.132.2.132.329 0 .128-.05.245-.132.329-.08.08-.188.131-.31.131-.12 0-.23-.05-.309-.131-.082-.084-.132-.2-.132-.329 0-.128.05-.245.132-.329zm.167-7.75c.198-.061.249-.037.285 0 .04.04.064.097.064.159h0v5.76c0 .062-.024.118-.064.159-.036.037-.087.061-.142.061-.056 0-.107-.024-.143-.061-.04-.04-.064-.097-.064-.159h0V5.72c0-.062.024-.118.064-.159z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.85,
    strokeWidth: 1.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.56323b0fb90a7324d16beccf34d3b730.svg";
export { ForwardRef as ReactComponent };